module.exports = __webpack_public_path__ + "img/children-f3.abc8c433.png";